const email = `
If you see a hidden email it means that the user opted out from receiving marketing updates.

An email with a badge next to it means that it’s a verified email.

An email without badge means that it hasn’t been verified yet.
`.trim();

const marketing = `
Marketing permissions of your subscribers.

<b>Yes</b> - means that they have <b>opted in</b> for receiving marketing emails from you.

<b>No</b> - means that they have <b>opted out</b> from receiving marketing emails from you.
`.trim();

const status = `This is the current subscription status of the user:

<b>Cancelled</b>: The user will not renew their subscription and is set to expire on the next billing date. Access to content will be available until the expiration date.

<b>Active</b>: The user has access to the content and will renew their subscription.

<b>Inactive</b>: The user no longer has access to your content and is unsubscribed.

<b>Billing</b> failed: Payment collection had an issue; the user needs to update their credit card details in the app.`;

const statusOtp = `This is the current subscription status of the user:

<b>Cancelled</b>: The user will not renew their subscription and is set to expire on the next billing date. Access to content will be available until the expiration date.

<b>Active</b>: The user has access to the content and will renew their subscription.

<b>Inactive</b>: The user no longer has access to your content and is unsubscribed.

<b>Billing</b> failed: Payment collection had an issue; the user needs to update their credit card details in the app.

<b>None</b>: The user never subscribed to you on this platform`;

const classification = `
The nature of your subscribers.

<b>Migrated</b> - Subscribers you had previously on another platform and then brought them to Playbook.

<b>Paid</b> - Subscribers who have paid for your subscription.

<b>Bulk uploads</b> - Subscribers who received a complimentary subscription as part of a deal you had with them.

<b>Trial</b> - Subscribers on a trial period, who may or may not convert paying subscribers.

<b>Free</b> - Subscribers who received a complimentary subscription from you.
`.trim();

const purchased = `Date of the most recent transaction.`;

const cancelled = `Date of the cancellation of  subscription by your subscriber.`;

const renews = `
Date of renewal or expiration of subscription.

Your cancelled subscribers might have access to your content for some time after cancellation depending on the type of their subscription.
`.trim();

const additional = `
Additional labels highlighting outstanding consumers.

<b>Recently churned</b> - Users whose subscriptions ended within the last three weeks and are now inactive.

<b>Recently converted</b> - Users who entered their first paid period within the last three weeks after completing a free trial.

<b>First purchase</b> - This user has started a new subscription with you. They may be on a trial (if they didn’t previously use a trial and a trial is available) or a paid membership. It’s possible that the user had a trial in the past, churned/became inactive, and has now restarted their subscription.
`.trim();

const otp = `Includes all one-time purchase products the user has access to.`;

const source = `Where your leads came from.`;

export default {
  email,
  marketing,
  status,
  classification,
  purchased,
  cancelled,
  renews,
  source,
  statusOtp,
  additional,
  otp,
};
